import { ISelectOption } from 'app/interfaces/ISelectOption';
import { Type } from 'shell-models-lib';

/***
 * Oracle V2 additional properties
 */
export type OracleAdditionalPropertiesKeyType =
    | 'encryptionClient'
    | 'encryptionTypesClient'
    | 'cryptoChecksumClient'
    | 'cryptoChecksumTypesClient'
    | 'initialLobFetchSize'
    | 'fetchSize'
    | 'statementCacheSize'
    | 'initializationString'
    | 'enableBulkLoad'
    | 'supportV1DataTypes'
    | 'fetchTswtzAsTimestamp'

export const oracleAdditionalPropertiesKeyList = [
    'encryptionClient',
    'encryptionTypesClient',
    'cryptoChecksumClient',
    'cryptoChecksumTypesClient',
    'initialLobFetchSize',
    'fetchSize',
    'statementCacheSize',
    'initializationString',
    'enableBulkLoad',
    'supportV1DataTypes',
    'fetchTswtzAsTimestamp'
];

export const oracleAdditionalPropertiesAdapts = {
    'encryptionClient': '*',
    'encryptionTypesClient': '*',
    'cryptoChecksumClient': '*',
    'cryptoChecksumTypesClient': '*',
    'initialLobFetchSize': '*',
    'fetchSize': '*',
    'statementCacheSize': '*',
    'initializationString': '*',
    'enableBulkLoad': '*',
    'supportV1DataTypes': '*',
    'fetchTswtzAsTimestamp': '*'
};

export const oracleAdditionalPropertiesKeyOptions: Array<ISelectOption<OracleAdditionalPropertiesKeyType>> = [
    {
        label: 'Encryption client',
        value: 'encryptionClient',
        type: Type.String
    },
    {
        label: 'Encryption types client',
        value: 'encryptionTypesClient',
        type: Type.String
    },
    {
        label: 'Crypto checksum client',
        value: 'cryptoChecksumClient',
        type: Type.String
    },
    {
        label: 'Crypto checksum types client',
        value: 'cryptoChecksumTypesClient',
        type: Type.String
    },
    {
        label: 'Initial LOB fetch size',
        value: 'initialLobFetchSize',
        type: Type.Int
    },
    {
        label: 'Fetch size',
        value: 'fetchSize',
        type: Type.Int
    },
    {
        label: 'Statement cache size',
        value: 'statementCacheSize',
        type: Type.Int
    },
    {
        label: 'Initialization string',
        value: 'initializationString',
        type: Type.String
    },
    {
        label: 'Enable bulk load',
        value: 'enableBulkLoad',
        type: Type.Boolean
    },
    {
        label: 'Support V1 data types',
        value: 'supportV1DataTypes',
        type: Type.Boolean
    },
    {
        label: 'Fetch TSWTZ as timestamp',
        value: 'fetchTswtzAsTimestamp',
        type: Type.Boolean
    }
];